import { get } from './_core.js';

export interface DashboardKpis {
  sessionCount: number;
  turnCount: number;
  totalCostNano: string;
  errorCount: number;
  errorRate: number;
  p95TurnDurationMs: number | null;
}

export interface DashboardTopUser {
  userId: string;
  email: string;
  totalCostNano: string;
}

export interface DashboardLiveSession {
  id: string;
  userId: string;
  email: string;
  moduleId: string | null;
  startedAt: string;
}

export interface DashboardRecentError {
  id: string;
  traceId: string;
  sessionId: string | null;
  kind: string;
  name: string;
  errorKind: string | null;
  startedAt: string;
}

export interface DashboardResponse {
  windowStart: string;
  kpis: DashboardKpis;
  topUsers: DashboardTopUser[];
  liveSessions: DashboardLiveSession[];
  recentErrors: DashboardRecentError[];
}

export async function fetchDashboard(): Promise<DashboardResponse> {
  const res = await get<DashboardResponse>('/admin/dashboard');
  return res.data;
}

export interface SparklineMetric<T extends number | string> {
  current: T;
  prev: T;
  buckets: T[];
}

export interface SparklineResponse {
  currentFrom: string;
  currentTo: string;
  prevFrom: string;
  prevTo: string;
  metrics: {
    sessionCount: SparklineMetric<number>;
    turnCount: SparklineMetric<number>;
    totalCostNano: SparklineMetric<string>;
    errorCount: SparklineMetric<number>;
  };
}

export async function fetchSparklines(): Promise<SparklineResponse> {
  const res = await get<SparklineResponse>('/admin/dashboard/sparklines');
  return res.data;
}
